import { useEffect, useRef } from 'react';

import useModal from '../../common/hooks/useModal';
import { useAppSelector } from '../../common/hooks/useThunkDispatch';
import { uiSelectors } from '../../common/selectors/uiSelectors';
import { FlyInType } from '../../common/store/structureDefinitions/modalState';
import { CncStep } from '../../common/store/structureDefinitions/uiState';
import { ga4NavigationTracking } from '../../common/tracking/ga4/navigation';

export const useTimeslotCncStepCloseTracking = () => {
    const { isOpen } = useModal(FlyInType.CncFlyIn);

    const cncStep = useAppSelector(uiSelectors.cnc.selectCurrentStep);

    const triggerWhen = useRef(false);

    useEffect(() => {
        if (triggerWhen.current && !isOpen && cncStep?.step === CncStep.TimeSlots) {
            ga4NavigationTracking.deliveryTime.close();
            triggerWhen.current = false;
        }
    }, [cncStep, isOpen]);

    // Start listen for state changes that may trigger tracking
    const startTimeslotCloseTrackingContext = () => {
        triggerWhen.current = true;
    };

    return {
        startTimeslotCloseTrackingContext,
    };
};
